import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { AlertTriangle, X, Eye } from 'lucide-react';

const GodModeBanner = () => {
  const { user, isImpersonating, originalUser, exitGodMode } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleExitGodMode = () => {
    exitGodMode();
    // Return to founder dashboard after exiting impersonation
    navigate('/founder/dashboard');
  };

  // ONLY show banner when actively impersonating another user
  // Do NOT show just because user is superadmin
  if (!isImpersonating) {
    return null;
  }

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 text-white py-2 px-4 shadow-lg"
      data-testid="god-mode-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 animate-pulse">
            <AlertTriangle className="w-5 h-5" />
            <span className="font-bold text-sm uppercase tracking-wider">🚨 GOD MODE</span>
          </div>
          
          <div className="h-4 w-px bg-white/30" />
          
          <div className="flex items-center gap-2">
            <Eye className="w-4 h-4" />
            <span className="text-sm">
              Viewing as{' '}
              <strong className="font-semibold">
                {user?.email || 'Unknown User'}
              </strong>
            </span>
          </div>
          
          {originalUser && (
            <>
              <div className="h-4 w-px bg-white/30" />
              <span className="text-xs opacity-75">
                (You: {originalUser.email})
              </span>
            </>
          )}
        </div>

        <Button
          onClick={handleExitGodMode}
          variant="outline"
          size="sm"
          className="bg-white/10 border-white/30 text-white hover:bg-white/20 hover:text-white"
          data-testid="exit-god-mode-btn"
        >
          <X className="w-4 h-4 mr-1" />
          Exit God Mode
        </Button>
      </div>
    </div>
  );
};

export default GodModeBanner;
